import React from 'react';
export function ProductSection() {
  return <section className="bg-blue-600 text-white py-16 px-6 text-center" data-id="element-175">
      <div className="max-w-3xl mx-auto" data-id="element-176">
        <p className="uppercase tracking-widest text-blue-200 text-sm font-semibold mb-2" data-id="element-177">
          La solución
        </p>
        <h2 className="text-4xl font-extrabold mb-4" data-id="element-178">📚 PACK DE INGLÉS 360</h2>
        <p className="text-xl text-blue-100 mb-6" data-id="element-179">
          El sistema N°1 para docentes de inglés en Argentina
        </p>
        <div className="grid md:grid-cols-3 gap-6 text-left" data-id="element-180">
          {[{
          icon: '📘',
          text: '12 tomos organizados por grado y año.'
        }, {
          icon: '✅',
          text: '180 actividades con secuencia completa.'
        }, {
          icon: '🎁',
          text: '6 bonus estratégicos incluidos.'
        }, {
          icon: '⚡',
          text: 'Todo listo para usar desde hoy.'
        }, {
          icon: '🖨️',
          text: 'Diseño optimizado para fotocopiadora.'
        }, {
          icon: '🇦🇷',
          text: 'Alineado al currículo argentino 2026.'
        }].map(item => <div key={item.text} className="bg-blue-500 bg-opacity-40 rounded-xl p-4 flex items-start gap-3" data-id="element-181">
              <span className="text-2xl" data-id="element-182">{item.icon}</span>
              <p className="text-sm text-white" data-id="element-183">{item.text}</p>
            </div>)}
        </div>
      </div>
    </section>;
}